module.exports = __webpack_public_path__ + "static/media/cinecruise-3.3c5ad995.jpg";